export enum RemarkTypes {
	candidate = 1,
	timesheet = 2,
	client = 3,
	booking = 4,
	student = 5,
	branch = 6,
	vacancy = 7,
}

export enum RemarksTags {
	BDCall = 1,
	CandidateCall = 2,
	ClientCall = 3,
	Meeting = 4,
	Compliance = 5,
	CandidateEmail = 6,
	CandidateSms = 7,
	//CustomTags
	LMEMTxt = 8,
	LMEMTxtFirstIntro = 9,
	LMEMTxtSecondIntro = 10,
	LMEMTxtThirdIntro = 11,
	LMEMTxtApplication = 12,
	LMEMTxtAreYouLooking = 13,
	Voicemail = 14,
	SentMessage = 15,
	BDCallAttempt = 16,
	BDCallSuccess = 17,
	BDEmailMessageSent = 18,
	BDEmailMessageSuccess = 19,
	ClientCallOther = 20,
	CATsCallAttempt = 21,
	CATsCallSuccess = 22,
	BDMassEmail = 23,
	ClientTermsSigned = 24,
	PreferredPartnerAgreedVerbally = 25,
	PreferredPartnerSigned = 26,
	RecruitingCallSuccess = 27,
	LMEMTxtRecruiting = 28,
	RecruitingEmailMessageSent = 29,
	RecruitingEmailMessageSuccess = 30,
	RecruitingMassEmail = 31,
	JobWorkedOnCompletely = 32,
	PreVetPermReg = 33,
	PreVetPermRegWithEmail = 34,
	VirtualRegBooked = 35,
	VirtualRegAttended = 36,
	VirtualRegAttendedWithEmail = 37,
	InPersonRegistrationBooked = 38,
	InPersonRegistrationAttended = 39,
	AvailabilityLMEMTXT = 40,
	AvailabilityEmailMessageSuccess = 41,
	AvailabilityCallSuccess = 42,
	CandidateCallOther = 43,
	CandidateCallAftercareSuccess = 44,
	CandidateCallAftercareAttempt = 45,
	SingleEshotSentUKBased = 46,
	SingleEshotSentOverseasBased = 47,
	WeeklyEshotSentUKBased = 48,
	WeeklyEshotSentOverseasBased = 49,
	AdvertPosted = 50,
	ClientVisitBooked = 51,
	ClientVisitAttended = 52,
	ClientDropAttended = 53,
	ClientVisitDropToVisitAttended = 54,
	ClientVisitVirtualBooked = 55,
	ClientVisitVirtualAttended = 56,
	InterviewFeedback = 57,
	InterestInTeachingOverseas = 58,
	SoloOdroRequestSent = 59,
	SoloOdroReceived = 60,
	SoloOdroSuccessFeedback = 61,
	SoloOdroFailedFeedback = 62,
	iCanFullyRegisteredCATA = 63,
	iCanFullyRegistered = 64,
	Other = 65,
	ClientEmail = 66,
	ComplianceReferenceChaseCall = 67,
	ComplianceReferenceChasedEmailMessage = 68,
	ComplianceCallSuccess = 69,
	ComplianceCallAttempted = 70,
	ComplianceIntro = 71,
	CandidateSentToCompliance = 72,
	ComplianceNote = 73,
	ComplianceInPersonInterviewCompliant = 74,
	CompliancePhoneVidInterviewCompliant = 75,
	ComplianceTempClearedFirstCheck = 76,
	ComplianceTempClearedSecondCheck = 77,
	ComplianceDirectCleared = 78,
	ComplianceDirectClearedSecondCheck = 79,
	ComplianceFinalChecksFail = 80,
	WelcomeToDunbarCall = 81,
	FinanceInvoiceSent = 82,
	SpecCall = 83,
	BookingFeedback = 84,
	RegistrationBooked = 85,
	SpecCallDM = 86,
	BDCallDM = 87,
	BDCallNonDM = 88,
	RelationshipCall = 89,
	RelationshipCallDM = 90,
	RelationshipCallNonDM = 91,
	ReferralCandidate = 92,
	NonContacted = 93,
	Online = 94,
	InterviewArranged = 95,
	ReferralSchool = 96,
	NSVDMBooked = 97,
	NSVDMAttended = 98,
	PSPVisitBooked = 99,
	PSPVisitAttended = 100,
	PSPSigned = 101,
	XPOVisitArrange = 102,
	XPOVisitAttended = 103,
	TelevetFormComplete = 104,
	InPersonRegistrationApproved = 105,
	InPersonRegistrationCancelled = 106,
	CVSentOnSpec = 107,
	SmsSent = 108,
	SmsReceived = 109,
	Offline = 110,
	Investigation = 111,
	EmailSentNo = 112,
	EmailReceivedNo = 113,
	Prescreen = 114,
	RegistrationMeeting = 115,
	Drop = 116,
	Visit = 117,
	IncidentReport = 118,
	InboundReply = 119,
	InboundInitiated = 120,
	OutboundReply = 121,
	OutboundInitiated = 122,
	EdunSystemEmail = 123,
	ExternalEmail = 124,
	CVSent = 125,
	StudentVisaRestrictedHours = 126,
	Under18 = 127,
	MedicalIssues = 128,
	ExpectantMother = 129,
	DBSDisclosure = 130,
	PFA = 131,
	TeamTeach = 132,
	FoodHygiene = 133,
	FirstSignOff = 134,
	ConsultantSignOff = 135,
	FinalSignOff = 136,
	DocumentsChased = 137,
	Tier2 = 138,
	Safeguarding = 139,
}
